window.OpusNoShadowRoot = true;
window.OpusApiCompareAtPrice = true;

let RENDER_TIMER = null;
let LAST_RENDER_TOKEN = null;

function renderSaveRow(renderToken, attempt = 0) {
  if (LAST_RENDER_TOKEN !== renderToken) return;

  const subtotalSection = document.querySelector(
    ".opus-subtotal-amount.money"
  );

  if (!subtotalSection) {
    if (attempt < 10) {
      RENDER_TIMER = setTimeout(() => {
        renderSaveRow(renderToken, attempt + 1);
      }, 100);

      return;
    }

    return;
  }

  document
    .querySelectorAll(".opus-save-row--dynamic")
    .forEach((el) => el.remove());

  const infoPrice = window.opusCartPriceInfo;
  const compareTotal = infoPrice?.totalPriceCompareAtPrice ?? 0;
  const saveTotal = infoPrice?.totalCompareAtPrice ?? 0;

  if (!compareTotal || saveTotal <= 0) return;

  const compareAmount = window.OpusConvertMoney(compareTotal);
  const saveAmount = window.OpusConvertMoney(saveTotal);

  if (LAST_RENDER_TOKEN !== renderToken) return;

  const locale = window?.Shopify?.locale || "";
  const saveText = locale.toLowerCase().startsWith("en")
    ? "Save"
    : "Spare";

  const row = document.createElement("div");
  row.className = "opus-save-row opus-save-row--dynamic";

  row.style.display = "flex";
  row.style.justifyContent = "flex-end";
  row.style.alignItems = "center";
  row.style.gap = "6px";
  row.style.fontSize = "13px";

  row.innerHTML = `
    <span style="color:#d82c0d;font-weight:500;white-space:nowrap;">
      (${saveText} ${saveAmount})
    </span>
    <span style="text-decoration:line-through;opacity:.7;white-space:nowrap;">
      ${compareAmount}
    </span>
  `;

  subtotalSection.insertAdjacentElement("afterbegin", row);
}

function handleCartEvents(event) {
  const data = event?.detail?.cart || event?.detail;
  if (!data) return;

  if (
    !(
      window.opusWidget?.plan?.plan === "Advanced" ||
      window.opusWidget?.plan?.plan === "Pro" ||
      window.opusWidget?.plan?.plan === "Basic"
    )
  ) {
    return;
  }

  if (RENDER_TIMER) {
    clearTimeout(RENDER_TIMER);
    RENDER_TIMER = null;
  }

  const renderToken = Symbol("opus-render");
  LAST_RENDER_TOKEN = renderToken;

  RENDER_TIMER = setTimeout(() => {
    renderSaveRow(renderToken);
  }, 100);
}

window.addEventListener("OpusCartChange", handleCartEvents);
window.addEventListener("OpusOpenCartState", handleCartEvents);